import React from 'react';
import AnalyticsWorkspaceInfo from './AnalyticsWorkspaceInfo';

const Workspaces: React.FC = () => {
  return <AnalyticsWorkspaceInfo />;
};

export default Workspaces;


